import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import GetAppRoundedIcon from "@mui/icons-material/GetAppRounded";

export class DownloadButton extends Component {
    state = { menuVisible: false };

    handleClick = e => {
        e.stopPropagation();
        if (!this.state.menuVisible) {
            document.addEventListener("click", this.handleOutsideClick, false);
            this.setState({ menuVisible: true });
        }
    };

    handleOutsideClick = () => {
        document.removeEventListener("click", this.handleOutsideClick, false);
        this.setState({ menuVisible: false });
    };

    componentWillUnmount() {
        document.removeEventListener("click", this.handleOutsideClick, false);
    }

    render() {
        return (
            <Container onClick={this.handleClick} data-testid="download-button">
                <GetAppRoundedIcon color="primary" aria-hidden="true" />
                {!this.state.menuVisible && <TextSpan>Download report</TextSpan>}
                {this.state.menuVisible && (
                    <MenuDiv onClick={this.handleOutsideClick}>{this.props.children}</MenuDiv>
                )}
            </Container>
        );
    }
}

DownloadButton.propTypes = {
    children: PropTypes.node
};

const Container = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
`;

export const MenuDiv = styled.div`
    position: absolute;
    z-index: 999;
    border: 1px solid #e2e1de;
    background-color: white;
    margin: 18px 0 0 25px;
    padding: 0 0 0 5px;
    width: 100px;
`;

export const TextSpan = styled.span`
    padding-left: 5px;
`;
